/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Created_On_HeaderInputs */

const en_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created On`)
};

const fr_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree le`)
};

const de_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

const it_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato il`)
};

const ru_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано в`)
};

const es_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado el`)
};

const zh_cn2_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建于`)
};

const ja_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const hi_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पर बनाया`)
};

const pt_pt2_explorer_table_created_on_header = /** @type {(inputs: Explorer_Table_Created_On_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado em`)
};

/**
* | output |
* | --- |
* | "Created On" |
*
* @param {Explorer_Table_Created_On_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_created_on_header = /** @type {((inputs?: Explorer_Table_Created_On_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Created_On_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_created_on_header(inputs)
	if (locale === "de") return de_explorer_table_created_on_header(inputs)
	if (locale === "it") return it_explorer_table_created_on_header(inputs)
	if (locale === "ru") return ru_explorer_table_created_on_header(inputs)
	if (locale === "es") return es_explorer_table_created_on_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_created_on_header(inputs)
	if (locale === "ja") return ja_explorer_table_created_on_header(inputs)
	if (locale === "hi") return hi_explorer_table_created_on_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_created_on_header(inputs)
	return en_explorer_table_created_on_header(inputs)
});